import { useSelector, useDispatch } from 'react-redux';
import { Creators } from '../../domain/useCases/setTutorialUseCase';

const useTutorial = () => {
  const dispatch = useDispatch();
  const { viewedTutorial, showTutorial } = useSelector(
    (state: any) => state.tutorial
  );

  const setTutorial = (show: boolean) => {
    dispatch(Creators.setTutorial(show));
    if (show) {
      document.getElementsByTagName('body')[0].classList.add('no-scroll');
    }
  };

  return { viewedTutorial, setTutorial, showTutorial };
};

export default useTutorial;
